<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-04 10:56:14
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-16 15:46:25
-->
<template>
  <div class="DetailedTransferOut">
    <Cashier v-bind="$attrs" :isJust="false" ></Cashier>
  </div>
</template>
<script>
import Cashier from '@/components/Cashier.vue';

export default {
  name: 'DetailedTransferOut',
  components: {
    Cashier,
  },
  data() {
    return {

    };
  },
};
</script>
<style scoped>
</style>
